import { render, staticRenderFns } from "./importCustomList.vue?vue&type=template&id=f28319b2&scoped=true&"
import script from "./importCustomList.vue?vue&type=script&lang=js&"
export * from "./importCustomList.vue?vue&type=script&lang=js&"
import style0 from "./importCustomList.vue?vue&type=style&index=0&id=f28319b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28319b2",
  null
  
)

export default component.exports